<ng-container [formGroup]="formGroup()">
  <div [class]="`col-span-2 flex items-center pl-10 ${readonly() ? 'text-states-light-white' : colorClasses[colorVariant()]}`">
    <span>{{ rowLabel() }}</span>
  </div>

  @if (side() === 'buccal') {
    <ng-container [ngTemplateOutlet]="!reversed() ? distal : mesial" />
  } @else {
    <ng-container [ngTemplateOutlet]="!reversed() ? mesial : distal" />
  }
  <lib-big-checkbox
    class="!h-10 !w-12"
    [variant]="colorVariant()"
    [highLight]="!readonly() && activeCursor() === 'central'"
    formControlName="central"
  ></lib-big-checkbox>

  @if (side() === 'buccal') {
    <ng-container [ngTemplateOutlet]="!reversed() ? mesial : distal" />
  } @else {
    <ng-container [ngTemplateOutlet]="!reversed() ? distal : mesial" />
  }

  <ng-template #distal>
    <lib-big-checkbox
      class="!h-10 !w-12"
      [variant]="colorVariant()"
      [highLight]="!readonly() && activeCursor() === 'distal'"
      formControlName="distal"
    ></lib-big-checkbox>
  </ng-template>

  <ng-template #mesial>
    <lib-big-checkbox
      class="!h-10 !w-12"
      [variant]="colorVariant()"
      [highLight]="!readonly() && activeCursor() === 'mesial'"
      formControlName="mesial"
    ></lib-big-checkbox>
  </ng-template>
</ng-container>
